import React, {Component} from 'react';
import axios from 'axios';
import Header from '../components/Header';
import NewsItem from '../components/NewsItem';

export default class News extends Component {

    constructor(props) {
        super(props);
        this.state = {
            news: [],
            loading: false
        };
    }

    componentDidMount() {
        this.setState({loading: true});

        axios.get('/ajax/news')
            .then((response) => {
                this.setState({news: response.data, loading: false});
            })
            .catch((error) => {
                this.setState({loading: false});
                console.log(error);
            });
    }

    render() {

        const spinnerStatus = this.state.loading ? ' on' : '';

        return (
            <div>
                <Header title="Nyheder"/>
                <div className="newslist container">
                <div className={'spinner' + spinnerStatus}></div>
                    <div className="col-12 col-lg-8">
                        {this.state.news.map((data) => {
                            return <NewsItem data={data} key={data.guid}/>
                        })}
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/News.js